import React from 'react';
import {inject, observer} from 'mobx-react';
import {withTranslation} from 'react-i18next';
import {useParams} from 'react-router';
import EncModal from '../../../../../../../../components/enc-modal';
import EncConfirm from '../../../../../../../../components/enc-confirm/EncConfirm';
import {AddIdentity} from './add-identity';
import {EditIdentity} from './edit-identity';

let UserIdentitiesModals = (props) => {
    const {
        t, userStore, userIdentitiesUIStore
    } = props;

    const params = useParams();

    function addIdentitySuccess() {
        userIdentitiesUIStore.closeAddIdentityModal();
    }

    function editIdentitySuccess() {
        userIdentitiesUIStore.closeEditIdentityModal();
    }

    function deleteIdentity() {
        if (userIdentitiesUIStore.selectedIdentity) {
            userStore.deleteIdentity(params.userId, userIdentitiesUIStore.selectedIdentity.value)
                .then(() => {
                    userIdentitiesUIStore.setSelectedIdentity(undefined);
                });
        }
        userIdentitiesUIStore.closeDeleteConfirm();
    }

    const selectedIdentity = userIdentitiesUIStore.selectedIdentity;

    return (
        <div>
            <EncModal
                isOpen={userIdentitiesUIStore.isAddIdentityModalOpen}
                closeModal={userIdentitiesUIStore.closeAddIdentityModal}>
                <AddIdentity
                    closeFunc={userIdentitiesUIStore.closeAddIdentityModal}
                    submitFunc={userStore.addIdentity(params.userId)}
                    onSuccess={addIdentitySuccess}
                    initialValues={{identityType: 'MTLS_CERTIFICATE', active: true}}
                />
            </EncModal>

            <EncModal
                isOpen={userIdentitiesUIStore.isEditIdentityModalOpen}
                closeModal={userIdentitiesUIStore.closeEditIdentityModal}>
                {selectedIdentity && (
                    <EditIdentity
                        closeFunc={userIdentitiesUIStore.closeEditIdentityModal}
                        submitFunc={userStore.updateIdentity(params.userId)}
                        onSuccess={editIdentitySuccess}
                        initialValues={{
                            identityType: selectedIdentity.identityType,
                            value: selectedIdentity.value,
                            description: selectedIdentity.description,
                            notBefore: selectedIdentity.notBefore,
                            notAfter: selectedIdentity.notAfter,
                            active: selectedIdentity.active
                        }}
                    />
                )}
            </EncModal>

            <EncConfirm
                openConfirm={userIdentitiesUIStore.isDeleteConfirmOpen}
                closeConfirm={userIdentitiesUIStore.closeDeleteConfirm}
                confirmFunc={deleteIdentity}
                confirmButtonLabel={t('user:user.delete.identity')}
                confirmTitle={t('user:user.confirm.delete.identity')}
                confirmMessage={
                    <p>{t('user:user.confirm.delete.identity.message', {
                        value: selectedIdentity ? selectedIdentity.value : ''
                    })}</p>
                }
            />
        </div>
    );
};

export default inject(
    'userStore',
    'userIdentitiesUIStore'
)(withTranslation(
    'user'
)(observer(UserIdentitiesModals)));
